import { locale as changeLocale, updateLocale } from 'moment';
import i18next from 'i18next';

const updatedLocales = [];

function loadLocale(language) {
  // this is a workaround for https://github.com/moment/moment/issues/5043
  const locale = language.split('-')[0];

  if (updatedLocales.includes(locale)) return;

  updatedLocales.push(locale);

  const t = i18next.getFixedT(locale);

  updateLocale(locale, {
    durationLabelsStandard: {
      S: t('common.time.millisecond'),
      SS: t('common.time.millisecond_plural'),
      s: t('common.time.second'),
      ss: t('common.time.second_plural'),
      m: t('common.time.minute'),
      mm: t('common.time.minute_plural'),
      h: t('common.time.hour'),
      hh: t('common.time.hour_plural'),
      d: t('common.time.day'),
      dd: t('common.time.day_plural'),
      w: t('common.time.week'),
      ww: t('common.time.week_plural'),
      M: t('common.time.month'),
      MM: t('common.time.month_plural'),
      y: t('common.time.year'),
      yy: t('common.time.year_plural'),
    },
  });
}

// eslint-disable-next-line import/prefer-default-export
export function changeMomentLocale(language) {
  loadLocale(language);
  changeLocale(language);
}
